import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import { Helmet } from 'react-helmet';

export default function Terms() {
  return (
    <><Helmet>
  <title>Terms & Conditions - Namami India Support Services</title>
  <meta
    name="description"
    content="Review the Terms & Conditions governing your use of Namami India Support Services’ website, operations, and services."
  />
  <meta
    name="keywords"
    content="Namami India, terms and conditions, service policy, website terms, user agreement"
  />
  <meta property="og:title" content="Terms & Conditions - Namami India" />
  <meta
    property="og:description"
    content="These Terms & Conditions outline the rules and policies for using Namami India's website and services."
  />
  <meta property="og:url" content="https://www.namamiindia.co.in/terms" />
  <link rel="canonical" href="https://www.namamiindia.co.in/terms" />
</Helmet>

    <Container maxWidth="lg" sx={{ py: 8 }}>
      <Typography variant="h3" fontWeight={700} gutterBottom color="primary">
        Terms of Service
      </Typography>
      <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
        Effective date: {new Date().toLocaleDateString()}
      </Typography>

      <Paper sx={{ p: 4, background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)" }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              1. Services Provided
            </Typography>
            <Typography variant="body1" paragraph>
              Namami India Support Services provides integrated facility management solutions 
              including housekeeping, landscaping, pest management, laundry services, catering, 
              and civil & MEP services.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              2. Service Agreements
            </Typography>
            <Typography variant="body1" paragraph>
              All services are provided based on formal agreements outlining scope, duration, 
              pricing, and terms of service delivery. Service terms may vary based on client 
              requirements and project specifications.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              3. Payment Terms
            </Typography>
            <Typography variant="body1" paragraph>
              Payment terms are as specified in individual service agreements. Generally, 
              payments are due within 30 days of invoice date unless otherwise agreed in writing.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              4. Cancellation Policy
            </Typography>
            <Typography variant="body1" paragraph>
              Service cancellations require 30 days written notice. Certain services may have 
              specific cancellation terms as outlined in service agreements.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              5. Limitation of Liability
            </Typography>
            <Typography variant="body1" paragraph>
              Our liability is limited to the value of the services provided. We are not liable 
              for indirect, special, or consequential damages.
            </Typography>
          </section>

          <section>
            <Typography variant="h5" gutterBottom fontWeight={600}>
              6. Governing Law
            </Typography>
            <Typography variant="body1">
              These terms are governed by and construed in accordance with the laws of India, 
              and you irrevocably submit to the exclusive jurisdiction of the courts in Bhubaneswar, Odisha.
            </Typography>
          </section>
        </Box>
      </Paper>
    </Container>
    </>
  );
}